import { Component, Vue, Prop } from 'vue-property-decorator'


import './StarRating.scss';


@Component({
  template: require('./StarRating.html')
})
export class StarRating extends Vue {

  @Prop({ default: 5 })
  starCount: number;

  @Prop({ default: 0.0 })
  rating: number;

}
